// extracted by mini-css-extract-plugin
module.exports = {"figure":"bj_g5","figure_isMargin":"bj_g6","figure__link":"bj_g7","figure__caption":"bj_g8"};